// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".u8-helper-box-container {\n  background-color: #f4f7fd;\n  border-color: #f4f7fd;\n  color: #C0C4CC;\n  padding: 10px;\n  border-width: 1px;\n  border-style: solid;\n  border-radius: 4px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  display: block;\n}\n.u8-helper-box-container span {\n  line-height: 20px;\n  font-size: 12px;\n  color: #C0C4CC;\n  white-space: pre-wrap;\n}", ""]);
// Exports
module.exports = exports;
